import React from 'react';
import { SmartGridRow } from '@app/ui';
import { SwitcherLink } from '@app/router';
import { AspectRatio } from '@stockx/ui';
import {
  Events,
  Categories,
  useGATrackEvent,
  AnalyticsAttributes,
} from '@app/analytics';
import { trackEvent as segmentTrackEvent, EVENTS, SCREENS } from '@app/segment';
import { VERTICAL_URL_PARTS } from '@app/config';
import { useVertical } from '@app/catalog/hooks';
import type { Tile } from '@app/types/generated';
import { Tile as TileWrapper } from '../TileCollection.styles';
import TileCollectionTileImage from './TileCollectionTileImage';

type TileCollection = {
  tiles: Tile[];
  title: string;
};

interface TrackEventProps {
  trackingEvent: string;
  position: number;
  destination: string;
  URL: string;
}

const TileCollectionRow = ({ title, tiles }: TileCollection) => {
  const gaTrack = useGATrackEvent();
  const [, setCurrentVertical] = useVertical();

  const handleTrackingEvent = ({
    trackingEvent,
    position,
    destination,
    URL,
  }: TrackEventProps) => {
    gaTrack(
      Events.TileCollectionClicked,
      Categories.Home,
      trackingEvent,
      null,
      {
        [AnalyticsAttributes.cdTileCollectionName]: title,
        [AnalyticsAttributes.cdDestinationType]: destination,
        [AnalyticsAttributes.cdPosition]: position,
      },
    );

    segmentTrackEvent(EVENTS.TILE_COLLECTION_CLICKED, {
      tileCollectionName: title,
      destination,
      screenName: SCREENS.HOME,
      trackingEvent,
      URL,
      position,
    });
  };

  return (
    <SmartGridRow columns={tiles?.length} gap={{ base: 2, lg: 4 }} isFullBleed>
      {tiles.map(({ id, image, link, trackingEvent }, index) => (
        <AspectRatio
          ratio={78 / 53}
          key={id}
          width={{ base: '163px', md: 'auto' }}
        >
          <TileWrapper>
            <SwitcherLink
              to={link?.url ?? ''}
              as={link?.urlType ?? ''}
              aria-label={link?.url}
              onClick={() => {
                const vertical = link?.url
                  ?.split('/')
                  .filter((piece) => VERTICAL_URL_PARTS.includes(piece))?.[0];

                if (vertical) {
                  setCurrentVertical(vertical);
                }

                handleTrackingEvent({
                  trackingEvent: trackingEvent ?? '',
                  position: index,
                  destination: link?.urlType ?? '',
                  URL: link?.url ?? '',
                });
              }}
            >
              <TileCollectionTileImage image={image} />
            </SwitcherLink>
          </TileWrapper>
        </AspectRatio>
      ))}
    </SmartGridRow>
  );
};

export default TileCollectionRow;
